import { GQLHotel } from '~/GqlTypes';

export default function(data: any): data is GQLHotel {
  return (
    data &&
    typeof data.__typename !== 'undefined' &&
    data.__typename === 'Hotel'
  );
}
